import React, { useContext } from 'react'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Container, TablePagination } from '@material-ui/core'
import CustomTableRow from './CustomTableRow'
import { PageContext } from '../Context/PageProvider'

import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'



export function TablePaginationActions(props) {
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div style={{ flexShrink: 0 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
            >
                <FirstPageIcon />
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            >
                <LastPageIcon />
            </IconButton>
        </div>
    );
}


function CustomTable({ t }) {
    const context = useContext(PageContext)
    const classes = useStyles()

    const handleChangePage = async (event, newPage) => {
        await context.setMessagePage(newPage + 1)
    }

    const messages = context.messages
    if (!messages) return null

    return (
        <Container className={classes.root} maxWidth="xl">
            <Container maxWidth="md">
                {messages.docs && messages.docs.map((row) => (<CustomTableRow row={row} key={row._id} />))}
                {messages.docs && messages.docs.length > 0 && <TablePagination
                    rowsPerPageOptions={[]}
                    colSpan={3}
                    count={messages?.totalDocs || 0}
                    rowsPerPage={messages?.limit || 0}
                    page={messages?.page - 1 || 0}
                    labelRowsPerPage=""
                    onChangePage={handleChangePage}
                    ActionsComponent={TablePaginationActions}
                />}
            </Container>
        </Container>

    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: theme.margin.small
    }
}))

export default withTranslation()(withRouter(CustomTable))